<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-4">
        <h2>{{$t('analytics')}}</h2>
      </div>
      <v-row>
        <v-col cols="6">
            <v-card flat elevation="0" class="mt-5 px-2 py-2" outlined height="">
                <v-toolbar dense flat :elevation="0">
                    <v-toolbar-title class="text-h6 font-weight-black ml-n4">{{$t('analyticsM.userGrowth')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dense class="mr-1 mt-1">Nov 6, 2019 - Nov 12, 2019</v-btn>
                    <v-select
                    :items="items"
                    color="primary"
                    dense
                    outlined
                    class="shrink mr-2 mt-7"
                    style="max-width: 150px"
                    v-model="date"
                    ></v-select>
                </v-toolbar>
                <v-card-text class="mt-5 pa-0"> 
                    <template >
                        <bar-chart :chartdata="sickData" :options="sickoptions"></bar-chart>
                    </template> 
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="6">
            <v-card flat elevation="0" class="mt-5 px-2 py-2" outlined height="">
                <v-toolbar dense flat :elevation="0">
                    <v-toolbar-title class="text-h6 font-weight-black ml-n4">{{$t('analyticsM.averageEngagementRate')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dense class="mr-1 mt-1">May, 2022</v-btn>
                    <v-select
                    :items="items"
                    color="primary"
                    dense
                    outlined
                    class="shrink mr-2 mt-7"
                    style="max-width: 150px"
                    v-model="date"
                    ></v-select>
                </v-toolbar>
                <v-card-text class="mt-5 pa-0"> 
                    <template >
                        <bar-chart :chartdata="sickData" :options="sickoptions"></bar-chart>
                    </template> 
                </v-card-text>
            </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
            <v-card flat elevation="0" class="mt-5 px-2 py-2" outlined height="">
                <v-toolbar dense flat :elevation="0">
                    <v-toolbar-title class="text-h6 font-weight-black ml-n4">{{ $t('analyticsM.averageRequestsReceived') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dense class="mr-1 mt-1">May, 2022</v-btn>
                    <v-select
                    :items="items"
                    color="primary"
                    dense
                    outlined
                    class="shrink mr-2 mt-7"
                    style="max-width: 150px"
                    v-model="date"
                    ></v-select>
                </v-toolbar>
                <v-card-text class="mt-5 pa-0"> 
                    <template >
                        <bar-chart :chartdata="sickData" :options="sickoptions"></bar-chart>
                    </template> 
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="6">
            <v-card flat elevation="0" class="mt-5 px-2 py-2" outlined height="">
                <v-toolbar dense flat :elevation="0">
                    <v-toolbar-title class="text-h6 font-weight-black ml-n4">{{ $t('analyticsM.registeredFarms') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dense class="mr-1 mt-1">May, 2022</v-btn>
                    <v-select
                    :items="items"
                    color="primary"
                    dense
                    outlined
                    class="shrink mr-2 mt-7"
                    style="max-width: 150px"
                    v-model="date"
                    ></v-select>
                </v-toolbar>
                <v-card-text class="mt-5 pa-0"> 
                    <template >
                        <bar-chart :chartdata="sickData" :options="sickoptions"></bar-chart>
                    </template> 
                </v-card-text>
            </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
            <v-card flat elevation="0" class="mt-5 px-2 py-2" outlined height="">
                <v-toolbar dense flat :elevation="0">
                    <v-toolbar-title class="text-h6 font-weight-black ml-n4">{{ $t('analyticsM.totalRegisteredAnimals') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dense class="mr-1 mt-1">May, 2022</v-btn>
                    <v-select
                    :items="items"
                    color="primary"
                    dense
                    outlined
                    class="shrink mr-2 mt-7"
                    style="max-width: 150px"
                    v-model="date"
                    ></v-select>
                </v-toolbar>
                <v-card-text class="pa-0" style="margin-top: 120px"> 
                    <template >
                        <bar-chart :chartdata="sickData" :options="sickoptions"></bar-chart>
                    </template> 
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="6">
            <v-card flat elevation="0" class="mt-5 px-2 py-2" outlined height="">
                <v-toolbar dense flat :elevation="0">
                    <v-toolbar-title class="text-h6 font-weight-black ml-n4">{{ $t('analyticsM.noOfAnimalUser') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dense class="mr-1 mt-1">May, 2022</v-btn>
                    <v-select
                    :items="items"
                    color="primary"
                    dense
                    outlined
                    class="shrink mr-2 mt-7"
                    style="max-width: 150px"
                    v-model="date"
                    ></v-select>
                </v-toolbar>
                <div class="d-flex mt-2">
                  <v-row no-gutters>
                    <v-col>
                        <p>{{$t('analyticsM.filterByUser')}}</p>
                        <v-select
                            :items="countries"
                            dense
                            outlined
                            class=" mr-2"
                            v-model="country"
                            :placeholder="$t('analyticsM.filterByUser')"
                        ></v-select>
                    </v-col>
                    <v-col>
                        <p>{{$t('analyticsM.filterByFarmName')}}</p>
                        <v-select
                            :items="regions"
                            dense
                            outlined
                            class=" mr-2"
                            v-model="region"
                            :placeholder="$t('analyticsM.filterByFarmName')"
                        ></v-select>
                    </v-col>
                    </v-row>
                </div>
                <v-card-text class="mt-5 pa-0"> 
                    <template >
                        <bar-chart :chartdata="sickData" :options="sickoptions"></bar-chart>
                    </template> 
                </v-card-text>
            </v-card>
        </v-col>
      </v-row>
      <v-row class="mt-5">
        <v-col cols="6">
            <v-card flat elevation="0" outlined class="pa-2">
                <v-toolbar dense flat :elevation="0">
                    <v-toolbar-title class="text-h6 ml-n4">{{ $t('analyticsM.noUserFarmGeographicalArea') }}</v-toolbar-title>
                </v-toolbar>
                <div class="d-flex">
                  <v-row no-gutters>
                    <v-col>
                        <p>{{ $t('analyticsM.filterByCountry') }}</p>
                        <v-select
                            :items="countries"
                            item-text="name"
                            item-value="id"
                            dense
                            outlined
                            class=" mr-2 wdt"
                            v-model="country"
                            :placeholder="$t('analyticsM.filterByCountry')"
                        ></v-select>
                    </v-col>
                    <v-col>
                        <p>{{ $t('analyticsM.filterByRegion') }}</p>
                        <v-select
                            :items="regions"
                            item-text="name"
                            item-value="roleNumber"
                            dense
                            outlined
                            class=" mr-2 wdt"
                            v-model="region"
                            :placeholder="$t('analyticsM.filterByRegion')"
                        ></v-select>
                    </v-col>
                    </v-row>
                    <v-btn class="pa-3 mt-11" color="primary" depressed dark>
                        {{ $t('update') }}
                    </v-btn>
                </div>
                <v-card-text class="pa-0">
                    <v-data-table
                        :headers="headers"
                        :items="dataItems"
                        :items-per-page="5"
                        hide-default-footer
                        :loading="loadingInseminator"
                        loading-text="Loading Data..."
                        :server-items-length="5"
                        class="elevation-0 rounded-table-header"
                    >
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="6">
            <GmapMap
                :center="{ lat: 10, lng: 10 }"
                :zoom="1"
                map-type-id="terrain"
                style="width: 100%; height: 360px"
              >
              </GmapMap>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import BarChart from "./BarChart.vue";

export default {
    components: {
        BarChart,
    },
    data(){
        return{
            date: this.$t('byMonth'),
            breadcrumbs: [
                {
                    text: this.$t('dashboard'),
                    disabled: false,
                    to: "/",
                },
                {
                    text: this.$t("analytics"),
                    disabled: true,
                },
            ],
            items: [
                this.$t('byMonth'),
                this.$t('byYear')
            ],
            sickData: {
                labels: [
                    this.$t('monday'),
                    this.$t('tuesday'),
                    this.$t('wednesday'),
                    this.$t('thursday'),
                    this.$t('friday'),
                    this.$t('saturday'),
                    this.$t('sunday'),
                ],
                datasets: [
                    {
                        label: this.$t("data"),
                        backgroundColor: "#489E16",
                        data: [62000, 40000, 20000, 35000, 60000, 13000, 50000],
                        borderWidth: 2,
                        borderRadius: 5,
                        borderSkipped: false,
                    }
                ],
            },
            sickoptions: {
                tooltips: {
                    displayColors: true,
                    callbacks: {
                    mode: "x",
                    },
                },
                scales: {
                    xAxes: [
                    {
                        gridLines: {
                        // display: false,
                        },
                    },
                    ],
                    yAxes: [
                    {
                        // stacked: true,
                        ticks: {
                        beginAtZero: true,
                        },
                        type: "linear",
                    },
                    ],
                },
                responsive: true,
                maintainAspectRatio: false,
                legend: { position: "top" },
            },
            headers: [
                {
                    text: this.$t("country"),
                    align: "start",
                    sortable: true,
                    value: "country",
                },
                { text: this.$t("region"), value: "region", sortable: true, },
                { text: this.$t("totalUser"), value: "totalUser", sortable: true, },
                { text: this.$t("totalFarm"), value: "totalFarm", sortable: true, },
            ],
            dataItems: [
                {
                    country: "Canada",
                    region: "-",
                    totalUser: 500,
                    totalFarm: 500
                },
                {
                    country: "France",
                    region: "-",
                    totalUser: 200,
                    totalFarm: 200
                },
                {
                    country: "Uganda",
                    region: "-",
                    totalUser: 300,
                    totalFarm: 300
                },
            ],
            countries: [
                { id: 1, name: 'Canada' },
                { id: 2, name: 'France' },
                { id: 3, name: 'Uganda' },
           
            ],
            country: null ,
            regions: [
                { roleNumber: 1, name: 'Eastern Canada' },
                { roleNumber: 2, name: 'Central Canada' },
                { roleNumber: 3, name: 'Western Canada' },
  
            ],
        }
    }
}
</script>

<style lang="scss" scoped>
/*::v-deep .v-select.v-text-field:not(.v-text-field--single-line) input {
    margin-top: 0;
    max-width: 5px;
}*/
</style>